module.exports = {
  back: 'Retour',
  cancel: 'Annuler',
  confirm: 'Confirmer',
  send: 'Envoyer',
};



// WEBPACK FOOTER //
// ./js/lang/fr/actions.js